export enum AdminAccessTypes {
    OrgAdmin = 'org_admin',
    BFAdmin = 'bf_admin'
}
